import ConsentApi from '../services/ConsentApi';
import Cookie from '../services/Cookie';
import GoogleTagManagerClient from '../services/GoogleTagManagerClient';

const setHasOptedOutOfThirdPartyDataSharing = async (profile = null) => {
  const consentTypeKey = 'hasOptedOutofThirdPartyDataSharing';
  const getCookieExpiration = () => {
    const expiration = new Date();
    const oneHour = 3600 * 1000;
    const time = expiration.getTime() + oneHour;
    expiration.setTime(time);
    return expiration.toUTCString();
  };

  const checkForTrueOptOutCookie = JSON.parse(Cookie.getCookie(consentTypeKey));

  if (checkForTrueOptOutCookie?.hasOptedOutofThirdPartyDataSharing) {
    Cookie.setCookie('_uetmsdns', 1);
    return;
  }

  const setThirdPartySharingCookie = (hasOptedOutofThirdPartyDataSharing, userId = null) => {
    const cookieExpiration = getCookieExpiration();
    const googleTagManagerData = {
      hasOptedOutofThirdPartyDataSharing,
      uid: userId
    };
    if (hasOptedOutofThirdPartyDataSharing) {
      Cookie.setCookie('_uetmsdns', 1);
    }
    Cookie.setCookie(consentTypeKey, JSON.stringify(googleTagManagerData), cookieExpiration);
    GoogleTagManagerClient.trackEvent(googleTagManagerData);
  };

  const userId = (profile != null && profile.userProfile && profile.userProfile.userId) || null;
  const isGpcEnabled = (navigator != null && navigator.globalPrivacyControl) || false;
  if (!userId) {
    setThirdPartySharingCookie(isGpcEnabled, userId);
    return;
  }

  const consentResponse = await ConsentApi.getUserThirdPartyConsentElection();
  const thirdPartyOptOutValue = isGpcEnabled || consentResponse;
  const cookie = Cookie.getCookie(consentTypeKey);
  const parsedCookieData = cookie != null && JSON.parse(cookie);
  const doesCookieExist = parsedCookieData && parsedCookieData.uid === userId;
  const isCookieSetCorrectly = doesCookieExist && (parsedCookieData.hasOptedOutofThirdPartyDataSharing || parsedCookieData.hasOptedOutofThirdPartyDataSharing === thirdPartyOptOutValue);

  if (isCookieSetCorrectly) {
    GoogleTagManagerClient.trackEvent(parsedCookieData);
    return;
  }
  setThirdPartySharingCookie(thirdPartyOptOutValue, userId);
};

export default setHasOptedOutOfThirdPartyDataSharing;
